import { NOTIFICATION_TYPES as T } from './notifications';

/**
 * One short line per notification (operator, 2026-10-04: concise, and a follow must read differently from a group
 * event). Returns `parts`: strings and `{ strong }` names, so the page and the toast bold the same words.
 * `kind` is 'person' (round avatar) or 'group' (square tile). Rows written before the actor/group embed, or whose
 * group is gone, fall back to the stored title.
 */
export function describeNotification(n) {
  const actor = n?.actor?.display_name || null;
  const group = n?.group?.name || null;
  const who = actor ? { strong: actor } : 'Someone';
  const grp = group ? { strong: group } : 'your group';
  switch (n?.type) {
    case T.FOLLOW:
      return { kind: 'person', parts: [who, ' followed you'] };
    case T.DM_MESSAGE:
      return { kind: 'person', parts: [n.title || 'New message'] };
    case T.JOIN_REQUEST:
      return { kind: 'group', parts: [who, ' asked to join ', grp] };
    case T.MEMBER_JOINED:
      return { kind: 'group', parts: [who, ' joined ', grp] };
    case T.JOIN_APPROVED:
      return { kind: 'group', parts: ['You’re in ', grp] };
    case T.JOIN_DENIED:
      return { kind: 'group', parts: [group ? grp : 'A group', ' declined your request'] };
    case T.QUEUE_MATCHED:
      return { kind: 'group', parts: ['You’re in ', grp] };
    case T.PROMOTED_TO_MANAGER:
      return { kind: 'group', parts: ['You’re a manager of ', grp] };
    case T.GROUP_EXPIRING:
      return { kind: 'group', parts: [group ? grp : 'Your group', ' closes soon'] };
    case T.GROUP_MESSAGE:
      return { kind: 'group', parts: [n.title || 'New messages'] };
    default:
      return { kind: 'person', parts: [n?.title || 'Notification'] };
  }
}

/** The second line, where one helps: a message preview. Everything else is one line. */
export function notificationPreview(n) {
  if (n?.type === T.GROUP_MESSAGE || n?.type === T.DM_MESSAGE) return n.message || null;
  return null;
}

/** "now", "5m", "3h", "2d", "Sep 28" - the row's right edge has room for one short word. */
export function shortAge(date, now = Date.now()) {
  const mins = Math.floor((now - new Date(date).getTime()) / 60000);
  if (!Number.isFinite(mins)) return '';
  if (mins < 1) return 'now';
  if (mins < 60) return `${mins}m`;
  if (mins < 1440) return `${Math.floor(mins / 60)}h`;
  if (mins < 10080) return `${Math.floor(mins / 1440)}d`;
  return new Date(date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

/** The types worth interrupting for (operator, 2026-10-04): someone followed you, or you're in a group. */
export const TOAST_TYPES = new Set([
  T.FOLLOW,
  T.JOIN_APPROVED,
  T.QUEUE_MATCHED,
  T.JOIN_REQUEST,
  T.MEMBER_JOINED,
]);
